module.exports = __webpack_public_path__ + "media/images/home/ic_email-c269ce8e4411adc0fd71d4261d06dcfc.svg";